import { useQuery } from '@tanstack/react-query';
import { GetUserResponse } from '@/types/api/user';
import api from '@/api';

type UserQueryKey = ['users', string];

export function useUserQuery(userId: string) {
  return useQuery<GetUserResponse, Error, GetUserResponse, UserQueryKey>({
    queryKey: ['users', userId],
    queryFn: () => api.user.get(userId),
    enabled: Boolean(userId),
  });
}
